import React, { Component } from 'react';
import homedata from '../../data/home.json';

class Privacy extends Component {
    render () {

        let factsInfo = homedata.privacy; // make sure you add `privacy` in home.json
        let sectionHeadingInfo = factsInfo.sectionHeading;

        const h4Style = {
            color: '#333',
            fontSize: '1.5rem',
            fontWeight: '600',
            marginTop: '30px',
            marginBottom: '15px',
            borderLeft: '4px solid #007bff',
            paddingLeft: '15px'
        };

        return (
            <section id="features" className="pt100 pb100">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-10 col-md-8 col-sm-10 offset-md-1 offset-sm-1">
                            <div className="section-title text-center mb60">
                                <h2 dangerouslySetInnerHTML={{ __html: sectionHeadingInfo.title }}></h2>
                                <hr className="lines" />
                                <div
                                    className="clearfix"
                                    style={{
                                        textAlign: 'left',
                                        maxWidth: '900px',
                                        padding: '30px',
                                        background: '#fff'
                                    }}
                                >
                                    
                                    <p>
                                        This Privacy Policy explains how <strong>Finneto</strong> (“Company”, “we”,
                                        “our”, or “us”) collects, uses, and protects personal information when you use
                                        our website and related services.
                                    </p>

                                    <p>
                                        By accessing or using this website, you agree to the collection and use of
                                        information in accordance with this Privacy Policy. If you do not agree, please
                                        do not use the website.
                                    </p>

                                    <h4 style={h4Style}>1. Company Information</h4>
                                    <p>Finneto operates through its associated legal entities, including:</p>
                                    <ul>
                                        <li>
                                            <strong>Lorlir LLC</strong>, Registered in Wyoming, United States
                                        </li>
                                        <li>
                                            <strong>Finixo IL Ltd</strong>, Registered in Israel
                                        </li>
                                    </ul>
                                    <p>Contact details are displayed in the website footer.</p>

                                    <h4 style={h4Style}>2. Information We May Collect</h4>
                                    <p>We may collect the following categories of information:</p>
                                    <ul>
                                        <li>
                                            <strong>Contact information</strong> – such as name, email address, phone
                                            number, and company name when you submit forms or contact us.
                                        </li>
                                        <li>
                                            <strong>Business information</strong> – such as your role, industry,
                                            website, and project details you choose to provide.
                                        </li>
                                        <li>
                                            <strong>Usage data</strong> – such as IP address, browser type, device
                                            information, pages visited, and time spent on the website.
                                        </li>
                                        <li>
                                            <strong>Technical data</strong> – cookies and similar technologies used to
                                            improve website performance and analytics.
                                        </li>
                                    </ul>

                                    <h4 style={h4Style}>3. How We Use Your Information</h4>
                                    <p>We may use the information we collect for the following purposes:</p>
                                    <ul>
                                        <li>To respond to your inquiries and provide customer support.</li>
                                        <li>To evaluate potential business relationships and opportunities.</li>
                                        <li>To operate, maintain, and improve our website and services.</li>
                                        <li>To send you relevant updates, communications, or marketing (where lawful).</li>
                                        <li>To comply with legal obligations and enforce our Terms &amp; Conditions.</li>
                                    </ul>

                                    <h4 style={h4Style}>4. Legal Bases for Processing (EU / EEA & Similar Regimes)</h4>
                                    <p>Where applicable (for example under EU/EEA or similar laws), we process personal data based on:</p>
                                    <ul>
                                        <li>
                                            <strong>Legitimate interests</strong> – such as operating and improving our
                                            business, communicating with prospects and clients, and securing our
                                            systems.
                                        </li>
                                        <li>
                                            <strong>Consent</strong> – where you have given us clear consent (for
                                            example, to receive certain marketing communications).
                                        </li>
                                        <li>
                                            <strong>Legal obligations</strong> – where we must retain or disclose data
                                            to comply with applicable laws.
                                        </li>
                                    </ul>

                                    <h4 style={h4Style}>5. Cookies & Tracking Technologies</h4>
                                    <p>
                                        We may use cookies and similar technologies to enhance user experience,
                                        analyze website traffic, and understand how visitors interact with our website.
                                    </p>
                                    <p>
                                        You can usually control cookies through your browser settings. Disabling
                                        cookies may affect certain features or functionality of the website.
                                    </p>

                                    <h4 style={h4Style}>6. Sharing of Information</h4>
                                    <p>We do not sell your personal information. We may share information with:</p>
                                    <ul>
                                        <li>
                                            <strong>Service providers</strong> – third parties that help us host the
                                            website, provide analytics, communications tools, or other business support.
                                        </li>
                                        <li>
                                            <strong>Professional advisors</strong> – such as lawyers, accountants, or
                                            consultants where necessary.
                                        </li>
                                        <li>
                                            <strong>Authorities or law enforcement</strong> – when required by law or
                                            to protect our rights, users, or the public.
                                        </li>
                                        <li>
                                            <strong>Corporate transactions</strong> – in connection with a merger,
                                            acquisition, asset sale, or similar event, where permitted by law.
                                        </li>
                                    </ul>

                                    <h4 style={h4Style}>7. International Data Transfers</h4>
                                    <p>
                                        As we operate internationally, your information may be transferred to and
                                        processed in countries other than your own. We take reasonable steps to ensure
                                        that any such transfers comply with applicable data protection laws and that
                                        your data remains protected.
                                    </p>

                                    <h4 style={h4Style}>8. Data Retention</h4>
                                    <p>
                                        We retain personal information only for as long as necessary to fulfill the
                                        purposes described in this Privacy Policy, or as required by law, regulation,
                                        or contractual obligations.
                                    </p>

                                    <h4 style={h4Style}>9. Data Security</h4>
                                    <p>
                                        We implement reasonable technical and organizational measures to protect
                                        personal information against unauthorized access, loss, misuse, or disclosure.
                                        However, no method of transmission or storage is completely secure, and we
                                        cannot guarantee absolute security.
                                    </p>

                                    <h4 style={h4Style}>10. Your Rights</h4>
                                    <p>
                                        Depending on your location and applicable law, you may have certain rights in
                                        relation to your personal information, such as:
                                    </p>
                                    <ul>
                                        <li>The right to access the personal data we hold about you.</li>
                                        <li>The right to request correction of inaccurate or incomplete data.</li>
                                        <li>The right to request deletion of your data, subject to legal obligations.</li>
                                        <li>The right to object to or restrict certain types of processing.</li>
                                        <li>
                                            The right to withdraw consent where processing is based on consent (without
                                            affecting the lawfulness of processing before withdrawal).
                                        </li>
                                    </ul>
                                    <p>
                                        To exercise these rights, please contact us using the details provided on the
                                        website. We may need to verify your identity before responding.
                                    </p>

                                    <h4 style={h4Style}>11. Children&apos;s Privacy</h4>
                                    <p>
                                        This website and our services are intended for business and professional use
                                        and are not directed to children. We do not knowingly collect personal
                                        information from individuals under the age of 18. If you believe we have
                                        collected such information, please contact us so we can remove it.
                                    </p>

                                    <h4 style={h4Style}>12. Links to Other Websites</h4>
                                    <p>
                                        Our website may contain links to third-party websites. We are not responsible
                                        for the privacy practices or content of those sites. We encourage you to review
                                        the privacy policies of any third-party websites you visit.
                                    </p>

                                    <h4 style={h4Style}>13. Changes to This Privacy Policy</h4>
                                    <p>
                                        We may update this Privacy Policy from time to time. The updated version will
                                        be posted on this page with a revised “Last updated” date. Your continued use
                                        of the website after any changes indicates your acceptance of the updated
                                        Privacy Policy.
                                    </p>

                                    <h4 style={h4Style}>14. Contact Information</h4>
                                    <p>
                                        If you have any questions or requests regarding this Privacy Policy or our data
                                        practices, please contact us using the details provided on the website footer.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </section>
        );
    }
}

export default Privacy;
